import axiosInstance from "../../Lib/axios";
import {
  GET_MESSAGE_ASSIGNED_TO_ME,
  GET_MESSAGE_ASSIGNED_TO_ME_FAILED,
  GET_SERVICE_TYPE_COLLECTION,
  GET_SERVICE_TYPE_COLLECTION_FAILED,
  GET_AUDIT_TRAIL,
  GET_AUDIT_TRAIL_FAILED,
  GET_SCHEDULE_SERVICE,
  GET_SCHEDULE_SERVICE_FAILED,
  GET_GROUP_LIST_FAILED,
  GET_GROUP_LIST_SUCCESSFULLY
} from "../types";

// Get all messages
export const getAssignedToMeMessage = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`crm/message/`, { params })
      .then((response) => {
        dispatch({
          type: GET_MESSAGE_ASSIGNED_TO_ME,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_MESSAGE_ASSIGNED_TO_ME_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// Get service type data
export const getServiceTypeCollection = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office-service-type-collection-v1/`, { params })
      .then((response) => {
        dispatch({
          type: GET_SERVICE_TYPE_COLLECTION,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SERVICE_TYPE_COLLECTION_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get audit trail data
export const getAuditTrail = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office-audit-trail-v1/`, { params })
      .then((response) => {
        dispatch({
          type: GET_AUDIT_TRAIL,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_AUDIT_TRAIL_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get schedule service
export const getScheduleService = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/field-office-dashboard-scheduled-v1/`, { params })
      .then((response) => {
        dispatch({
          type: GET_SCHEDULE_SERVICE,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_SCHEDULE_SERVICE_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};

// get schedule service
export const getFranchiseGroupList = (params) => {
  return (dispatch) => {
    return axiosInstance
      .get(`/crm/user-group/`, { params })
      .then((response) => {
        dispatch({
          type: GET_GROUP_LIST_SUCCESSFULLY,
          data: response.data,
        });
      })
      .catch((error) => {
        if (error && error.response) {
          if (error.response.status === 401 || error.response.status === 403) {
            window.location.assign('/')
            localStorage.clear();
            sessionStorage.clear();
          }
          if (error.response) {
            dispatch({
              type: GET_GROUP_LIST_FAILED,
              data: error.response.data,
            });
          }
        }
      });
  };
};